<template>
  <div>
    <div style="display: flex; gap: 60px">
      <div style="display: flex; gap: 15px; align-items: center">
        <div style="font-size: 14px;">
          {{ $t('base.device') }}
        </div>
        <div
          v-for="item in device_list" :key="item.label"
          style="border: 1px solid #e5e5e5; border-radius: 40px; color: #333; cursor: pointer; font-size: 14px; height: 32px; padding: 6px 16px;"
          :style="item.value === device ? 'border-color: #ee4d2d; color: #ee4d2d;' : ''"
          @click="device = item.value; m__query()">
          {{ item.label }}
        </div>
      </div>
      <div style="display: flex; gap: 15px; align-items: center">
        <div style="font-size: 14px;">
          {{ $t('base.date') }}
        </div>
        <div
          v-for="item in period_list" :key="item.label"
          style="border: 1px solid #e5e5e5; border-radius: 40px; color: #333; cursor: pointer; font-size: 14px; height: 32px; padding: 6px 16px;"
          :style="item.value === period ? 'border-color: #ee4d2d; color: #ee4d2d;' : ''"
          @click="period = item.value; m__query()">
          {{ item.label }}
        </div>
      </div>
    </div>

    <div
      style="display: flex; margin-top: 30px; align-items: center; gap: 50px;">
      <div style="display: flex; gap: 15px; align-items: center">
        <div style="font-size: 14px;">
          {{ $t('base.operator') }}
        </div>
        <div>
          <el-select type="soft-grey" size="small" value="" v-model="operator">
            <el-option v-for="item in operator_list" :key="item.type" :value="item.type" :label="item.label"
                       :disabled="!operation_list.length"></el-option>
          </el-select>
        </div>
      </div>
      <div style="display: flex; gap: 15px; align-items: center">
        <div style="font-size: 14px;">
          {{ $t('ads.event_type.label') }}
        </div>
        <div>
          <el-cascader v-model="event_type_model" :options="event_type_options" style="width: 500px"
                       size="small" clearable></el-cascader>
        </div>
      </div>
      <div>
        <!--        <el-button size="small" icon="el-icon-download">{{ $t('base.export_data') }}</el-button>-->
      </div>
    </div>

    <div style="margin-top: 30px">
      <el-table :data="operation_list" v-loading="loading.get_data">
        <el-table-column :label="$t('base.update_time')" max-width="150px">
          <template slot-scope="scope">
            {{ scope.row.update_time * 1000 | moment('DD-MM-YYYY HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.operator')" max-width="150px">
          <template slot-scope="scope">
            <template v-if="operator_list.find(i => i.type === scope.row.operator.type)">
              {{ operator_list.find(i => i.type === scope.row.operator.type).label }}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.device')" max-width="150px">
          <template slot-scope="scope">
            <template v-if="device_list.find(i => i.value === scope.row.device)">
              {{ device_list.find(i => i.value === scope.row.device).label }}
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.event_type')" max-width="150px">
          <template slot-scope="scope">
            <div style="text-transform: capitalize">
              {{ scope.row.event_type.replace(/_/ig, ' ') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('base.details')" width="310px">
          <template slot-scope="scope">
            <div style="margin-bottom: 5px">
              <div v-html="scope.row.pretty_detail_list.join(`<br>`)"
                   style="line-height: 23px; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis;"
                   :style="scope.row.see_more ? 'display: inline' : 'display: -webkit-box;'">
              </div>
              <div v-if="scope.row.pretty_detail_list.length > 4 && !scope.row.see_more">
                <strong class="text-primary" style="font-size: 13px; cursor: pointer"
                        @click="scope.row.see_more = true">
                  {{ $t('base.see_more') }}
                </strong>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="current_page" :page-size="page_size" layout="prev, pager, next, total"
                     :total="operation_count" @current-change="m__query()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'component__shopee_operation_history',

  props: {
    campaign_id: null,
    shop: null,
    sp_user: null,
    show_dialog: false
  },

  data() {
    return {
      period: 'today',
      period_list: [
        {
          label: this.$t('day.today'),
          value: 'today'
        },
        {
          label: this.$t('day.yesterday'),
          value: 'yesterday'
        },
        {
          label: this.$t('day.past7days'),
          value: 'past7days'
        },
        {
          label: this.$t('day.past30days'),
          value: 'past30days'
        },
      ],
      device: null,
      device_list: [
        {
          label: this.$t('base.all'),
          value: null
        },
        {
          label: this.$t('base.pc'),
          value: 'pc'
        },
        {
          label: this.$t('base.app'),
          value: 'app'
        },
        {
          label: this.$t('base.others'),
          value: 'others'
        },
      ],
      operator: null,
      operator_list: [
        {
          type: 'system',
          label: this.$t('base.system')
        },
        {
          type: 'admin',
          label: this.$t('base.admin')
        },
        {
          type: 'shop_user',
          name: this.shop.username,
          label: this.shop.username
        },
        {
          type: 'sub_account',
          label: this.$t('base.sub_account')
        }
      ],

      event_type_list: [],
      event_type_model: [],
      event_type_options: [
        {
          label: this.$t('ads.event_type.campaign_creation'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.campaign_creation'),
              value: 'campaign_creation'
            }
          ]
        },
        {
          label: this.$t('ads.event_type.campaign_status_change'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.pause_ad'),
              value: 'pause_ad'
            },
            {
              label: this.$t('ads.event_type.resume_ad'),
              value: 'resume_ad'
            },
            {
              label: this.$t('ads.event_type.start_ad'),
              value: 'start_ad'
            },
            {
              label: this.$t('ads.event_type.stop_ad'),
              value: 'stop_ad'
            },
            {
              label: this.$t('ads.event_type.restart_ad'),
              value: 'restart_ad'
            },
            {
              label: this.$t('ads.event_type.delete_ad'),
              value: 'delete_ad'
            },
          ]
        },
        {
          label: this.$t('ads.event_type.campaign_setting_change'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.change_schedule'),
              value: 'change_schedule'
            },
            {
              label: this.$t('ads.event_type.change_target_roas'),
              value: 'target_roas_change'
            },
            {
              label: this.$t('ads.event_type.change_placement'),
              value: 'change_placement'
            },
            {
              label: this.$t('ads.event_type.update_target_audience'),
              value: 'update_target_audience'
            },
            {
              label: this.$t('ads.event_type.change_bidding_method'),
              value: 'change_bidding_strategy'
            },
            {
              label: this.$t('ads.event_type.billing_mode_switch'),
              value: 'billing_mode_change'
            },
          ]
        },
        {
          label: this.$t('ads.event_type.campaign_budget_change'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.change_budget'),
              value: 'change_budget'
            }
          ]
        },
        {
          label: this.$t('ads.event_type.creative_change'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.update_creative'),
              value: 'update_creative'
            }
          ]
        },
        {
          label: this.$t('ads.event_type.keyword_change'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.update_keywords'),
              value: 'update_keywords'
            }
          ]
        },
        {
          label: this.$t('ads.event_type.toggle_change'),
          value: null,
          children: [
            {
              label: this.$t('ads.event_type.new_product_boost'),
              value: 'new_product_boost_toggle_change'
            },
            {
              label: this.$t('ads.event_type.enhanced_bid_price'),
              value: 'ecpc_change'
            }
          ]
        }
      ],

      operation_list: [],
      operation_count: 0,
      current_page: 1,
      page_size: 10,

      loading: {
        get_data: false,
        export_data: false
      },
    }
  },

  watch: {
    'show_dialog': function () {
      if (this.show_dialog) {
        this.m__query()
      }
    },

    'event_type_model': function () {
      this.event_type_list = this.event_type_model && this.event_type_model[1]
        ? [this.event_type_model[1]]
        : []
      this.m__query()
    }
  },

  methods: {
    // async m__export_data() {
    //   const trigger_response = await this.sp_user.marketing_pas_report_trigger_or_get_previous({
    //     start_time,
    //     end_time,
    //     header: {},
    //     report_type: 'product_manual__single_detail',
    //     campaign_id: this.c__campaign_id
    //   })
    // },

    async m__query() {
      if (!this.campaign_id) return

      this.loading.get_data = true
      // this.operation_list = []
      // this.operation_count = 0

      try {
        let start_time = this.dayjs().startOf('day'), end_time = this.dayjs().endOf('day')

        if (this.period === 'yesterday') {
          start_time = this.dayjs().subtract(1, 'day').startOf('day')
          end_time = this.dayjs().subtract(1, 'day').endOf('day')
        }
        if (this.period === 'past7days') {
          start_time = this.dayjs().subtract(1, 'week').startOf('day')
          end_time = this.dayjs().endOf('day')
        }
        if (this.period === 'past30days') {
          start_time = this.dayjs().subtract(1, 'month').startOf('day')
          end_time = this.dayjs().subtract(1, 'day').endOf('day')
        }

        const form = {
          campaign_id: this.campaign_id,
          start_time: start_time.unix(),
          end_time: end_time.unix(),
          offset: (this.current_page - 1) * this.page_size,
          limit: this.page_size,
          filter: {
            device_list: this.device ? [this.device] : [],
            operator_list: this.operator ? [this.operator] : [],
            event_type_list: this.event_type_list
          }
        }

        const query_result_count_response = await this.sp_user.marketing_pas_operation_log_query_result_count(form)
        this.operation_count = query_result_count_response.data.total

        const response = await this.sp_user.marketing_pas_operation_log_query(form)
        for (const item of response.data.operation_list) {
          item.see_more = false
        }
        this.operation_list = response.data.operation_list
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_shopee_operation_history.vue